import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { Box } from '@wds/box';

const useStyles = createUseStyles(theme => {
  const { breakpoints, spacing } = theme;

  return {
    container: {
      [`@media screen and (max-width: 1400px)`]: {
        marginLeft: `${spacing['6']}px`,
        marginRight: `${spacing['6']}px`,
      },
    },
    leftColumn: {
      width: '300px',
      minWidth: '258px',
      position: 'sticky',
      top: 0,
      marginBottom: `${spacing['8']}px`,
      display: 'none',
      [`@media screen and (min-width: ${breakpoints.md}px)`]: {
        display: 'block',
      },
    },
  };
});

export const LeftNavLayout = ({ nav, children }) => {
  const { container, leftColumn } = useStyles();

  return (
    <Box display="flex" className={container}>
      <div className={leftColumn}>{nav}</div>
      <Box flexItemGrow>{children}</Box>
    </Box>
  );
};

LeftNavLayout.propTypes = {
  nav: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default LeftNavLayout;
